import ServiceBusController from "servicestack/service-bus.controller";

export default class FormioBrowserController extends ServiceBusController {
  $onInit(...args) {
    const $ctrl = this;
    console.debug("$onInit", this, args);
    $ctrl.form = { components: [], display: "form", page: 0 };
  }

  $onChanges(...args) {
    console.debug("$onChanges", args);
    this.applySettings();
  }

  updateForm(...args) {
    console.debug("$updateForm", args);
  }

  applySettings() {
    this.message = "Applying settings...";
    this.$ioc("$timeout")(() => {
      delete this.formId;
      delete this.message;
      delete this.sidebar;
    }, 888);
  }

  toggleHotspots() {
    this.sidebar =
      this.sidebar === mattertagsSidebar ? false : mattertagsSidebar;
  }

  toggleSettings() {
    this.sidebar = this.sidebar === settingsSidebar ? false : settingsSidebar;
  }

  codeBlock() {
    return `
<formio
  width="${this.width}"
  height="${this.height}"
  space-id="${this.spaceId}"
  api-key="${this.apiKey}"
  sdk-version="${this.sdkVersion}"
  hide-billboards="${this.hideBillboards}"
  hide-forms="${this.hideTags}"
  spaces="${JSON.stringify(this.spaces || {})}"
>
</formio>    
    `;
  }
}
